import ArticleAd from "./ArticleAd";

export default ArticleAd;
